import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { ApiDetailTab } from '../../types/app';

export const currentApiDefinitionSelector = (state: RootState, slug?: string) => {
  const currentDetail = state.apiDetail?.currentApiDefinition;
  if (currentDetail && slug && currentDetail.slug === slug) {
    return currentDetail;
  }

  if (slug) {
    const apiDefinitions = state.api?.apiDefinitions ?? [];
    const foundDefinition = apiDefinitions.find((api) => api.slug === slug);
    if (foundDefinition) {
      return foundDefinition;
    }
  }

  return null;
};
export const apiDetailLoadingSelector = (state: RootState) => state.apiDetail?.loading ?? false;
export const apiDetailErrorSelector = (state: RootState) => state.apiDetail?.error ?? null;

export const availableTabsSelector = createSelector(
  [currentApiDefinitionSelector],
  (currentApiDefinition) => {
    const tabs: ApiDetailTab[] = [];

    const enFeaturesLength = currentApiDefinition?.authoredContent.en?.features?.length ?? 0;
    const nlFeaturesLength = currentApiDefinition?.authoredContent.nl?.features?.length ?? 0;

    if (enFeaturesLength > 0 || nlFeaturesLength > 0) {
      tabs.push(ApiDetailTab.FEATURES);
    }

    if (currentApiDefinition?.hasDocumentationArticles) {
      tabs.push(ApiDetailTab.GUIDES);
    }

    if (currentApiDefinition?.hasOpenApiSpec) {
      tabs.push(ApiDetailTab.SPECS);
    }

    return tabs;
  },
);
